import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { CourseService } from './course.service';
import { CourseObjective } from './course-objective.model';

@Injectable({
    providedIn: 'root',
})
export class CourseObjectivesService {
    isLoading:boolean = false;
    isAdd:boolean = false;
    isEditable:boolean = false;
    errorMessage:string = '';
    objectives: CourseObjective[];

    constructor(
        private apiService: ApiService,
        private courseService: CourseService
    ) {}

    get(): void {
        this.errorMessage = '';
        this.isLoading = true;

        this.apiService.getCourseObjectives(this.course).subscribe(
            (data) => {
                this.objectives = data.map((objective) => {return new CourseObjective(objective);});
                this.isLoading = false;
            },
            (error) => {
                this.isLoading = false;
                this.objectives = [];
                this.errorMessage =
                    'An error occurred, and we were unable to load Objectives for this Course.';
            }
        );
    }

    get course() {
        return this.courseService.course;
    }

}
